export const JSSDKApi = 'wx/JSSDK/' 